import * as React from 'react';
import styled from 'styled-components';
import { TInvestmentReturn } from '../models/investmentReturn.model';
import { Tooltip } from 'react-tippy';
import { ToolTipDataComponent } from '../tooltipdata/tooltipdata';
import './progressBar.style.css';
import 'react-tippy/dist/tippy.css';
// import 'bootstrap/dist/js/bootstrap.js';
// import 'bootstrap/dist/css/bootstrap.css';

import {
  currencyFormatterWithDecimals,
  formatCurrency,
} from '@assetmark/utilities';
// import { TooltipData } from './';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px;
`;

export interface TInvestmentReturnProgressProps {
  height?: number;
  investmentAmount: number;
  allSeries?: TInvestmentReturn[];
  seriesReturns: TInvestmentReturn;
}

export const ProgressBarComponent = ({
  height,
  investmentAmount,
  allSeries,
  seriesReturns,
}: TInvestmentReturnProgressProps) => (
  <Tooltip
    html={
      <ToolTipDataComponent
        averageReturn={seriesReturns.AverageReturn}
        lossPercent={seriesReturns.LossPercent}
        averageReturnPercent={seriesReturns.AverageReturnPercent}
        gainPercent={seriesReturns.GainPercent}
      />
    }
    animation="fade"
    inertia={true}
    offset={130}
    distance={-230}
    position="bottom"
    animateFill={false}
    arrow={false}
  >
    <div className=" progress-vertical-bar top">
      <div className="datalabel">
        ${currencyFormatterWithDecimals(seriesReturns.Gain)}
      </div>
      <div
        className="rect"
        style={{
          minHeight: calculateBarHeight(
            investmentAmount,
            seriesReturns.Gain,
            height,
            allSeries,
          ),
        }}
      />
    </div>
    <div className="bottom">
      <div
        className="rect"
        style={{
          minHeight: calculateBarHeight(
            investmentAmount,
            seriesReturns.Loss,
            height,
            allSeries,
          ),
        }}
      />
      <div className="datalabel">
        {formatCurrency(currencyFormatterWithDecimals(seriesReturns.Loss))}
      </div>
    </div>
  </Tooltip>
);

ProgressBarComponent.defaultProps = {};

function findMinMax(
  investmentAmount: number,
  allSeries?: TInvestmentReturn[],
): number {
  let min = 0;
  let max = 0;

  const base = investmentAmount;

  allSeries.map((ret, index) => {
    const loss = base - ((ret.Loss || 0) + investmentAmount);
    const gain = (ret.Gain || 0) + investmentAmount - base;
    min = Math.min(min, loss);
    max = Math.max(max, gain);
  });

  return Math.abs(min - max);
}

function calculateBarHeight(
  investmentAmount: number,
  value?: number,
  height?: number,
  allSeries?: TInvestmentReturn[],
) {
  const maxHeight = (height || 0) / 2;
  const range = findMinMax(investmentAmount, allSeries);

  const ratio = range / maxHeight;
  value = Math.abs(value || 0);

  return value / ratio + 'px';
}
